<template>
    <div class="datepicker-wrapper">
        <ValidationProvider :rules="rules" v-slot="v">
            <div class="flex justify-between datepicker-external">
                <div class="flex-1 datepicker-text" v-if="label || v.errors.length">
                    <label class="label" v-if="label" v-html="label"></label>
                    <p class="subtext" v-if="subtext" v-html="subtext"></p>
                    <p v-if="v.errors.length" class="!opacity-100 subtext text-error">{{ v.errors[0] }}</p>
                </div>
                <div v-if="hint">
                    <HintComponent :hint="hint" />
                </div>
            </div>
            <div class="datepicker-container">
                <input v-model="date" :id="id" :name="name" type="date" :class="[v.errors.length ? 'has-errors' : '', date ? 'filled' : '']" />
                <img :src="global.app.url + 'images/icons/calendar.svg'" class="datepicker-icon" />
            </div>
        </ValidationProvider>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ValidationProvider } from "vee-validate";
import HintComponent from "@components/misc/HintComponent";

export default {
    name: "DatepickerComponent",
    props: {
        name: { type: String, default: "" }, // "Name" prop for naming the input
        id: { type: String, default: "" }, // "id" prop for naming the input
        label: { type: String, default: "" }, // Label used for the input
        subtext: { type: String, default: "" }, // text below the main label
        rules: { type: String, default: "required"}, // The validation rules set on the input. See VeeValidate for available rules
        hint: { type: String, default: "" }, // For the little "?" that appears with a hint for the specific input field
        value: { type: String }
    },
    components: {
        ValidationProvider
    },
    computed: {
        ...mapGetters(["global"]),
    },
    data: function () {
        return {
            date: this.value
        };
    },
    watch: {
		date(value) {
			this.date = value;
			this.$emit('input', this.date);
            this.$emit('change', this.date);
		},
        value(value) { // Used to detect hydration
			this.date = value;
		}
	}
};
</script>
